import { useDispatch, useSelector } from 'react-redux'
import { useState, useMemo } from 'react';
import {
    activeOverlayTeeth,
} from "../../Domain/Scene/Handler/OverlayHandler";
import { vectorIsNonZero } from 'Domain/Scene/Handler/MandiAdjustHandler';
import { DropdownMenu } from 'Ui/Layer/components/common/DropdownMenu';

/**
 * Component DentalsDisplay - button maxi, button mandi
 * @returns {JSX}
 */
export const DentalsDisplay = ({ onEditMode }) => {

    const
        dispatch = useDispatch(),
        { AnimationReducer, ViewportReducer } = useSelector((state) => state),
        metas = AnimationReducer.metas

    const viewportMode = useSelector((state) => state.ViewportReducer.viewportMode);
    const selectedVersion = useSelector((state) => state.ViewportReducer.selectedVersion);
    const mandiAdjust = useSelector((state) => state.ViewportReducer.mandiAdjust);

    const isMobileLayout = useSelector((state) => {
        const g = state.LayoutReducer?.global
        return !!(g?.isPortrait || g?.isMobileLandscape)
    })

    const [overlayEnabled, setOverlayEnabled] = useState(false);
    const [overlayType, setOverlayType] = useState('maloc'); // 'maloc' | 'setup'

    const bitejumpExists = vectorIsNonZero(mandiAdjust);

    const applyOverlayState = (nextEnabled, nextType) => {
        if (!nextEnabled) {
            activeOverlayTeeth('none')
            return
        }
        activeOverlayTeeth(nextType)
    }


    const handleDesktopOverlayToggle = () => {
        const nextEnabled = !overlayEnabled
        setOverlayEnabled(nextEnabled)
        applyOverlayState(nextEnabled, overlayType)
    }

    const handleDesktopSelectType = (type) => {
        setOverlayType(type)
        applyOverlayState(overlayEnabled, type)
    }

    const handleMobileToggle = (type) => {
        const isCurrentlyActive = overlayEnabled && overlayType === type
        const nextEnabled = !isCurrentlyActive
        setOverlayType(type)
        setOverlayEnabled(nextEnabled)
        applyOverlayState(nextEnabled, type)
    }

    const desktopMenu = useMemo(() => {
        const isActive = overlayEnabled
        const iconSrc = isActive ? './malloc--enabled.svg' : './malloc--disabled.svg'
        return (
            <DropdownMenu
                trigger={
                    <button
                        key='malocBtn'
                        className={`btnMaloc dental-display-btn ${isActive ? 'is-active' : ''}`}
                        onClick={handleDesktopOverlayToggle}
                        type="button"
                    >
                        <img src={iconSrc} alt='maloc_img' />
                    </button>
                }
            >
                <button
                    type="button"
                    onClick={() => handleDesktopSelectType('maloc')}
                    className={overlayType === 'maloc' ? 'dropdown-selected' : ''}
                >
                    Malocclusion
                </button>
                <button
                    type="button"
                    onClick={() => handleDesktopSelectType('setup')}
                    className={overlayType === 'setup' ? 'dropdown-selected' : ''}
                >
                    Setup
                </button>
            </DropdownMenu>
        )
    }, [overlayEnabled, overlayType, handleDesktopOverlayToggle, handleDesktopSelectType])

    return (
        <>
            {metas.treatment?.attachment !== 'none' && (
                <button className={`dental-display-btn ${ViewportReducer.attachmentVisibility ? 'is-active' : ''}`} key='attachmentBtn' onClick={() => dispatch({
                    type: 'ATTACHMENT_VISIBLE',
                    payload: !ViewportReducer.attachmentVisibility
                })}>
                    <img src={ViewportReducer.attachmentVisibility ? 'attachment-on.svg' : 'attachment-off.svg'} alt='attachment_icon' />
                </button>
            )}

            {metas.treatment?.ipr !== 'none' && (
                <button className={`dental-display-btn ${ViewportReducer.strippingVisibility ? 'is-active' : ''}`} key='iprBtn' onClick={() => dispatch({
                    type: 'STRIPPING_VISIBLE',
                    payload: !ViewportReducer.strippingVisibility
                })} disabled={onEditMode || selectedVersion !== -1 || viewportMode === 'comparative'}>
                    <img src={ViewportReducer.strippingVisibility ? 'ipr-on.svg' : 'ipr-off.svg'} alt='ipr_icon' />
                </button>
            )}
            {isMobileLayout ? (
                <>
                    <button
                        type="button"
                        className={`dental-display-btn is-overlay-maloc ${overlayEnabled && overlayType === 'maloc' ? 'is-active' : ''}`}
                        onClick={() => handleMobileToggle('maloc')}
                        aria-label="Malocclusion"
                        title="Malocclusion"
                    >
                        <img
                            src={overlayEnabled && overlayType === 'maloc' ? './malloc--enabled.svg' : './malloc--disabled.svg'}
                            alt='maloc_img'
                        />
                        <span className="dental-overlay-badge">M</span>
                    </button>
                    <button
                        type="button"
                        className={`dental-display-btn is-overlay-setup ${overlayEnabled && overlayType === 'setup' ? 'is-active' : ''}`}
                        onClick={() => handleMobileToggle('setup')}
                        aria-label="Setup"
                        title="Setup"
                    >
                        <img
                            src={overlayEnabled && overlayType === 'setup' ? './malloc--enabled.svg' : './malloc--disabled.svg'}
                            alt='setup_img'
                        />
                        <span className="dental-overlay-badge">S</span>
                    </button>
                </>
            ) : (
                desktopMenu
            )}

            {bitejumpExists && (
                <button
                    key='bitejumpBtn'
                    onClick={() => dispatch({
                        type: 'SET_MANDI_ADJUST_ACTIVE',
                        payload: !ViewportReducer.mandiAdjustActive
                    })}
                    className={`dental-display-btn ${ViewportReducer.mandiAdjustActive ? 'is-active' : ''}`}
                >
                    <img
                        src='./bitejump.svg'
                        alt='bitejump_img'
                        className={ViewportReducer.mandiAdjustActive ? 'bitejump-active' : 'bitejump-inactive'}
                    />
                </button>
            )}
        </>
    )
}
